import { SearchXIcon, MessageCircleIcon } from 'lucide-react';
import { useCatalog } from '../../contexts/CatalogContext';
import { useOverlayActions } from '../../contexts/StoreContext';
import { founder, salon } from '../../data/content';
import { shopLabels } from '../../data/shopLabels';
import { btnPrimary, btnSecondary } from '../../ui/styles';
import { homeBestsellers } from '../home/homeRules';
import { ProductGrid } from './ProductGrid';

/** Zoveel favorieten als uitweg: genoeg om door te klikken, niet zo veel dat het een tweede shop wordt. */
const FALLBACK_COUNT = 3;
type Props = {
  query: string;
  onClear: () => void;
};

/**
 * Geen resultaat is geen doodlopende weg: zeg eerlijk wat er niet is, bied drie
 * uitwegen (wissen, huidadvies, Sarah zelf) en laat de favorieten zien.
 */
export function ShopEmpty({
  query,
  onClear
}: Props) {
  const {
    openQuiz
  } = useOverlayActions();
  const {
    products
  } = useCatalog();
  const favourites = homeBestsellers(products, FALLBACK_COUNT);
  const term = query.trim();
  return <div className="mt-8" role="status" data-id="element-7165" data-mp="8bgx8sodt6mm">
      <div className="bg-shell px-6 py-12 text-center ring-1 ring-line sm:px-10 sm:py-14" data-id="element-7166" data-mp="8cibt74lwb93">
        <SearchXIcon className="mx-auto h-6 w-6 text-clay" strokeWidth={1.5} aria-hidden="true" data-id="element-7167" data-mp="3asx9hi6dfg9" />
        <h2 className="mt-5 type-title text-ink" data-id="element-7168" data-mp="3uix9954tzmle">
          {term ? <>Niets gevonden voor “{term}”</> : 'Geen match binnen deze filters'}
        </h2>
        <p className="mx-auto mt-3 max-w-md text-[15px] leading-relaxed text-muted" data-id="element-7169" data-mp="r283hld2ogws">
          {term ? `Misschien heet het bij mij anders, of verkoop ik het bewust niet. Vertel ${founder.firstName} wat je zoekt: vaak is er een beter alternatief.` : 'Zet een filter uit, of laat me meekijken naar wat jouw huid nodig heeft.'}
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-3" data-id="element-7170" data-mp="capsy32zfekt">
          <button type="button" onClick={openQuiz} aria-haspopup="dialog" className={btnPrimary} data-id="element-7171" data-mp="19sy8bfm7edsa">
            Doe de huidtest
          </button>
          <button type="button" onClick={onClear} className={btnSecondary} data-id="element-7172" data-mp="14zn0pc9khszb">
            {term ? 'Wis zoeken en filters' : 'Wis de filters'}
          </button>
        </div>
        <a href={salon.whatsapp} target="_blank" rel="noreferrer" className="mt-5 inline-flex items-center gap-2 py-2 text-[14px] text-muted underline-offset-4 transition-colors duration-150 ease-soft hover:text-ink hover:underline" data-id="element-7173" data-mp="347lifybv03l1">
          <MessageCircleIcon className="h-4 w-4 text-clay" strokeWidth={1.5} aria-hidden="true" data-id="element-7174" data-mp="2gi109hnj5act" />
          Of app {founder.firstName} wat je zoekt
          <span className="sr-only" data-id="element-7175" data-mp="26kmjfgxp2jjz">{shopLabels.viaWhatsApp}</span>
        </a>
      </div>

      {favourites.length > 0 && <div className="mt-14" data-id="element-7176" data-mp="2bixs3oc96o0m">
          <h3 className="type-title text-ink" data-id="element-7177" data-mp="2bk94udnof63v">Wat cliënten het vaakst meenemen</h3>
          <ProductGrid products={favourites} data-id="element-7178" data-mp="4uktzoyjb7uv" />
        </div>}
    </div>;
}